"use client";
import React, { useState, useRef, useEffect } from "react";
import BlogCard from "~/components/reusables/blog-card";
import Image from "next/image";
import PaginationComponent from "~/components/reusables/pagination-component";

export const BlogAuthorList = ({ blogs }) => {
  const blogListRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOption, setSortOption] = useState("Latest");
  const blogsPerPage = 9;

  useEffect(() => {
    const initialPage = parseInt(
      localStorage.getItem("currentPage") || "1",
      10,
    );
    const max = Math.ceil(blogs.length / blogsPerPage);
    if (initialPage < max) {
      setCurrentPage(initialPage);
    }
  }, []);

  // Function to sort blogs
  const sortBlogs = (blogs, sortOption) => {
    return blogs.sort((a, b) => {
      const dateA = new Date(a.attributes.publishDate).getTime();
      const dateB = new Date(b.attributes.publishDate).getTime();
      return sortOption === "Latest" ? dateB - dateA : dateA - dateB;
    });
  };

  // Sorted blogs
  const sortedBlogs = sortBlogs([...blogs], sortOption);

  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  // Get current page blogs
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = sortedBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (typeof window !== "undefined") {
      localStorage.setItem("currentPage", pageNumber.toString());
    }
  };

  useEffect(() => {
    if (blogListRef.current && currentPage !== 1) {
      blogListRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [currentPage]);

  return (
    <div ref={blogListRef} className="container relative my-[60px]">
      <div
        className="absolute right-[30px] top-[-50px] z-10 hidden w-[1px] bg-rainbow-b2 md:block 2xl:right-0"
        style={{
          height: "calc(100% - 260px)",
        }}
      ></div>
      <div className="z-1 absolute right-[-20px] top-[31px] hidden h-[1px] w-4/12 bg-rainbow-r2 md:block  lg:w-6/12 xl:right-[-50px]"></div>
      <Image
        unoptimized
        src="/images/graphics/middle-diamond.png"
        alt="Diamond"
        width="0"
        height="0"
        className="absolute right-[22px] top-[23px] z-[11] hidden w-[16px] md:block 2xl:right-[-8px]"
      />
      <div className="relative ">
        <h2 className="font-h2 inline-block bg-white">
          Blogs from this author
        </h2>
      </div>
      <div className="relative my-[50px] ">
        {blogs.length ? (
          <div>
            <div className="mt-[50px] grid grid-cols-1 gap-5 md:mt-[80px] md:grid-cols-2 md:gap-[38px] lg:gap-[70px] xl:grid-cols-3">
              {currentBlogs.map((blog, i) => (
                <div
                  key={i}
                  className="relative min-h-[380px] md:min-h-[520px]"
                >
                  <BlogCard blog={blog} size="md" />
                </div>
              ))}
            </div>
            {totalPages > 1 && (
              <PaginationComponent
                totalPages={totalPages}
                currentPage={currentPage}
                paginate={paginate}
              />
            )}
            {blogs.length < 4 && (
              <div className="mt-32">
                <h2 className="font-h2">Explore recent articles</h2>
              </div>
            )}
          </div>
        ) : (
          <div>
            <h4 className="font-h4">No results found.</h4>
          </div>
        )}
      </div>
    </div>
  );
};
